class ProductDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    this.renderEstimate();
  }

  renderEstimate() {
    const today = this.startOfDay(new Date());
    const isPreorder = this.dataset.isPreorder === "true";
    const handlingMinDays = this.integerValue("handlingMinDays");
    const handlingMaxDays = Math.max(handlingMinDays, this.integerValue("handlingMaxDays"));
    const [transitMinDays, transitMaxDays] = this.transitRange();

    let fulfillmentMinDate = today;
    let fulfillmentMaxDate = today;

    if (isPreorder) {
      const readyDate = this.parseLocalDate(this.dataset.preorderReadyDate);

      if (readyDate) {
        const effectiveReadyDate = readyDate > today ? readyDate : today;
        fulfillmentMinDate = effectiveReadyDate;
        fulfillmentMaxDate = effectiveReadyDate;
      } else {
        const preorderMinDays = this.integerValue("preorderMinDays");
        const preorderMaxDays = Math.max(preorderMinDays, this.integerValue("preorderMaxDays"));
        fulfillmentMinDate = this.addBusinessDays(today, preorderMinDays);
        fulfillmentMaxDate = this.addBusinessDays(today, preorderMaxDays);
      }
    }

    const dispatchMinDate = this.addBusinessDays(fulfillmentMinDate, handlingMinDays);
    const dispatchMaxDate = this.addBusinessDays(fulfillmentMaxDate, handlingMaxDays);
    const arrivalMinDate = this.addBusinessDays(dispatchMinDate, transitMinDays);
    const arrivalMaxDate = this.addBusinessDays(dispatchMaxDate, transitMaxDays);

    this.querySelector("[data-delivery-estimate-arrival]").textContent = this.formatRange(
      arrivalMinDate,
      arrivalMaxDate,
    );
  }

  transitRange() {
    const countryCode = (this.dataset.countryCode || "").toUpperCase();
    let prefix = "international";

    if (countryCode === "UA") {
      prefix = "ukraine";
    } else if (countryCode === "US") {
      prefix = "us";
    }

    const minDays = this.integerValue(`${prefix}MinDays`);
    const maxDays = Math.max(minDays, this.integerValue(`${prefix}MaxDays`));

    return [minDays, maxDays];
  }

  integerValue(name) {
    const value = Number.parseInt(this.dataset[name] || "0", 10);
    return Number.isFinite(value) ? Math.max(0, value) : 0;
  }

  addBusinessDays(date, days) {
    const result = new Date(date.getTime());
    let remainingDays = Math.max(0, days);

    while (remainingDays > 0) {
      result.setDate(result.getDate() + 1);

      if (result.getDay() !== 0 && result.getDay() !== 6) {
        remainingDays -= 1;
      }
    }

    return result;
  }

  parseLocalDate(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || "");

    if (!match) {
      return null;
    }

    const year = Number(match[1]);
    const month = Number(match[2]) - 1;
    const day = Number(match[3]);
    const date = new Date(year, month, day, 12);

    if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) {
      return null;
    }

    return date;
  }

  startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12);
  }

  formatRange(fromDate, toDate) {
    const locale = document.documentElement.lang || window.Shopify?.locale || "en";
    const formatter = new Intl.DateTimeFormat(locale, { month: "short", day: "numeric" });

    if (fromDate.getTime() === toDate.getTime()) {
      return formatter.format(fromDate);
    }

    if (typeof formatter.formatRange === "function") {
      return formatter.formatRange(fromDate, toDate);
    }

    return `${formatter.format(fromDate)} – ${formatter.format(toDate)}`;
  }
}

if (!window.customElements.get("product-delivery-estimate")) {
  window.customElements.define("product-delivery-estimate", ProductDeliveryEstimate);
}
